import { DropdownItemComponent } from './dropdown-item/dropdown-item.component';
import { AlertItemComponent } from './alert-item/alert-item.component';
import { RateItemComponent } from './rate-item/rate-item.component';
import { TextFieldItemComponent } from './text-field-item/text-field-item.component';
import { RadioItemComponent } from './radio-item/radio-item.component';
import { CheckboxItemComponent } from './checkbox-item/checkbox-item.component';
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation,
    Type,
} from '@angular/core';
import { Choice, ChoiceItem, ChoiceItemValueChange } from '../../../../typings';
import { CHOICE_ITEMS_TYPES } from '../../../../constants';

@Component({
    selector: 'serviceos-ng-choice-item',
    templateUrl: './choice-item.component.html',
    styleUrls: ['./choice-item.component.scss'],
})
export class ChoiceItemComponent implements OnInit {
    @Input()
    public settings!: ChoiceItem;

    @Input()
    public parentSettings!: Choice | ChoiceItem;

    @Output()
    public changeChoiceItemValue: EventEmitter<ChoiceItemValueChange> = new EventEmitter();

    /**
     * Component container reference for feature use in dynamically build component
     */
    @ViewChild('dynamicChoiceItemContainer', {
        read: ViewContainerRef,
        static: true,
    })
    public dynamicChoiceItemContainer!: ViewContainerRef;

    constructor() {}

    ngOnInit(): void {
    if (!this.settings?.type) {
        console.warn('No type provided in settings:', this.settings);
        return;
    }

    const widgetComponent = this.generateWidgetComponent(
        this.settings.type,
        this.settings
    );

    if (!widgetComponent) {
        console.warn('Unsupported widget type:', this.settings.type);
        return;
    }

    this.dynamicChoiceItemContainer.clear();

    const componentRef = this.dynamicChoiceItemContainer.createComponent(widgetComponent);

    componentRef.instance.settings = this.settings;
    componentRef.instance.parentSettings = this.parentSettings;

    if (componentRef.instance.changeChoiceItemValue) {
        componentRef.instance.changeChoiceItemValue.subscribe((event: ChoiceItemValueChange) => {
            this.changeChoiceItemValue.emit(event);
        });
    }
}


    /**
     * Generate widget component by given type
     * @param {string} type
     */
    private generateWidgetComponent(type: string, item: ChoiceItem): Type<any> | null {
        type = this.returnTrueType(type, item);

        switch (type) {
            case CHOICE_ITEMS_TYPES.Checkbox:
                return CheckboxItemComponent;
            case CHOICE_ITEMS_TYPES.Radio:
                return RadioItemComponent;
            case CHOICE_ITEMS_TYPES.TextField:
                return TextFieldItemComponent;
            case CHOICE_ITEMS_TYPES.Rate:
                return RateItemComponent;
            case CHOICE_ITEMS_TYPES.Alert:
                return AlertItemComponent;
            case CHOICE_ITEMS_TYPES.Dropdown:
                return DropdownItemComponent;
            default:
                return null;
        }
    }

    /**
     * Return modify type base on customize.
     * @param type ChoiceItemType
     * @param item Item
     * @returns
     */
    returnTrueType(type: string, item: ChoiceItem): string {
        return type;
    }
}
